import React, { useEffect } from 'react';
import style from './button.module.css'
export const TelecomBtn = ({title,onSetClick,status}) => {
    return(
        <button onClick={() => {onSetClick()}} className={`${style['telecom-btn']} ${style['telecom-btn-'+status]}`}>{title}</button>
    );
}